<template>
  <div>
    <app-button-create
      class="border-green mb-5"
      color="green"
      @click="newReceipt()"
    >
      <!-- :hidden="currentUser.role_id !== 1" -->
      <span class="text-green font-bold text-lg">領収書</span>
      <span class="text-green text-lg">［政務活動申請しないもの］</span>
      <span class="text-green font-bold text-sm">を</span>
      <span class="text-green font-bold text-lg">新規追加</span>
    </app-button-create>
  </div>
  <receipts-table-header></receipts-table-header>
  <receipts-table></receipts-table>
  <receipt-dialog v-if="isOpen && type === 'receipt'"></receipt-dialog>
</template>

<script>
import { onMounted, watch } from 'vue'
import ReceiptsTableHeader from '@/components/layout/receipts/ReceiptsTableHeader'
import ReceiptsTable from '@/components/layout/receipts/ReceiptsTable'
import ReceiptDialog from '@/components/layout/receipts/ReceiptDialog.vue'
import AppButtonCreate from '@/components/ui/AppButtonCreate'
import { useDialog } from '@/services/useDialog'
import { useReceiptDialog } from '@/services/receipt/useReceiptDialog'
import { useReceipts } from '@/services/receipt/useReceipts'
import { useYearSelector } from '@/services/useYearSelector'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'Receipts',

  components: {
    ReceiptsTableHeader,
    AppButtonCreate,
    ReceiptsTable,
    ReceiptDialog,
  },
  setup() {
    const { receiptDialog } = useReceiptDialog()
    const { getReceipts, resetCurrentReceipt } = useReceipts()
    const { currentYear, resetYear } = useYearSelector()
    const { openDialog, isOpen, type } = useDialog()
    const { currentUser } = useCurrentUser()

    onMounted(async () => {
      resetYear()
      await getReceipts(currentYear.value)
    })

    watch(currentYear, async currentYear => {
      await getReceipts(currentYear)
    })

    const newReceipt = () => {
      resetCurrentReceipt()
      openDialog('receipt')
      receiptDialog.isPreview = false
      receiptDialog.isPreviewEnabled = false
      receiptDialog.isPreviewRegistered = false
    }

    return { ...useReceiptDialog(), newReceipt, isOpen, currentUser, type }
  },
}
</script>
